import type { IconDefinition } from '../index.tsx';

export const iconAngleUp: IconDefinition = {
  prefix: 'fas',
  iconName: 'iconAngleUp',
  icon: [
    448,
    512,
    [],
    '',
    'M201.4 137.4c12.5-12.5 32.8-12.5 45.3 0l160 160c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0L224 205.3 86.6 342.6c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3l160-160z',
  ],
};
